module.exports = __webpack_public_path__ + "img/vertical_5_1_8017.de186fa0.png";